import ScreenService from "./services/ScreenService";
import BackButton from "./assets/backButton.svg";
import GearButton from "./assets/gearButton.svg";
import { getModelConfig } from "./utils/models";
import SupportInfo from "./components/Activation/SupportInfo";
import SalesInfo from "./components/Activation/SalesInfo";
import SalesCard from "./components/Activation/SalesCard";
import SalesLogos from "./components/Activation/SalesLogos";
import StyledQRCode from "./components/Activation/StyledQRCode";
import { useActivationFlow } from "./hooks/useActivationFlow";
import "./ActivationScreen.scss";

const ActivationLanding = ({ setStep, config, handleKeyDown }) => {
    const { onlyAvailableHelper, coBrandedLogo, salesCTAText, salesPhone, hidePromo,
            headerTitle, headerSubtitle, landingTitle, landingSubtitle, activateButtonText } = config;
    console.log(config);
    return (
        <div className="activation">
            <div className="sales-screen-container">
                <div className="sales-header">
                    <div className="sales-header-title">{headerTitle}</div>
                    <div className={`sales-header-subtitle ${hidePromo ? "sales-header-subtitle-non-promo" : ""}`}>
                        {headerSubtitle}</div>
                </div>
                <div className="sales-container">
                    <div className="activation-cta-container">
                        <div className="activation-cta-copy">
                            {landingTitle && <div className="copy-titles">
                                <div className="copy-title">{landingTitle}</div>
                            </div>}
                            <div className="copy-subtitles">
                                <div className="qr-activation-subtitle">{landingSubtitle} </div>
                            </div>
                        </div>
                        <button tabIndex={-1} autoFocus onKeyDown={(event) => handleKeyDown(event, 2)} onClick={() => setStep(2)} className="activate-button">
                            {activateButtonText}
                        </button>
                        <div className="activation-cta-footer">
                            <SupportInfo />
                        </div>
                    </div>
                    {!hidePromo && <div className="separator"></div>}
                    {!hidePromo && <div className="sales-info-container">
                        <SalesCard salesCTAText={salesCTAText} salesPhone={salesPhone} onlyAvailableHelper={onlyAvailableHelper} />
                    </div>}
                </div>
                <div className="sales-container">
                    <SalesLogos coBrandedLogo={coBrandedLogo} />
                </div>
            </div>
        </div>
    );
};

const NewActivationScreen = ({ code, setStep, config, handleKeyDown }) => {
    const { isMultiStep, coBrandedLogo, instructionTitle, qrPairingTitle, qrPairingSubtitle,
            computerPairingTitle, computerPairingSubtitlePrefix, computerPairingSubtitleSuffix,
            activationCodeLabel } = config;
    const qrLink = `${process.env.REACT_APP_REMOTE_CONTROL}pair/${code}`;

    return (
        <div className="activation">
            {isMultiStep && (
                <button tabIndex={-1} autoFocus onClick={() => setStep(1)} onKeyDown={(event) => handleKeyDown(event, 1)} className="back-button">
                    <img src={BackButton} alt="Back button" />
                </button>
            )}
            <div className="instructions">
                <div className="instruction-title">{instructionTitle}</div>
            </div>
            <div className="possible-activations">
                <div className="qr-activation-container">
                    <div className="qr-activation-title">{qrPairingTitle}</div>
                    <div className="qr-activation-subtitle-section">
                        <div className={ScreenService.isVertical ? "qr-activation-subtitle-vertical" : "qr-activation-subtitle"}>{qrPairingSubtitle}</div>
                    </div>
                    <StyledQRCode value={qrLink} width={258} height={258} margin={15} style={{ borderRadius: "18px" }} />
                </div>
                <div className="separator"></div>
                <div className="activation-code-container">
                    <div className="code-title">{computerPairingTitle}</div>
                    <div className="code-subtitle-section">
                        <div className={ScreenService.isVertical ? "code-subtitle-vertical" : "code-subtitle"}>
                            {computerPairingSubtitlePrefix}<b>{process.env.REACT_APP_COMPUTER_PAIRING_MANAGER_LINK}</b>{computerPairingSubtitleSuffix}
                        </div>
                    </div>
                    <div className="code-content-container">
                        <div className={ScreenService.isVertical ? `code-title-contrast-vertical` : "code-title-contrast"}>{activationCodeLabel}</div>
                        <div className={`${ScreenService.isVertical ? "vertical-code" : "code"} activation-code-content`}>{code}</div>
                        <SalesInfo/>
                    </div>
                </div>
            </div>
            <div className="contact">
                <SupportInfo everpassLogo={true} coBrandedLogo={coBrandedLogo} />
            </div>
            <button id="checks-button" className="hidden">
                <img src={GearButton} alt="Gear button" />
            </button>
        </div>
    );
};

const ActivationSteps = ({ onActivationComplete }) => {
    const activationConfig = getModelConfig().activationScreen;
    const { step, setStep, code } = useActivationFlow(onActivationComplete, activationConfig);

    const handleKeyDown = (event, targetStep) => {
        const { key } = event;
        if (key === "Enter") {
            setStep(targetStep);
        }
    };


    if (step === 1) {
        return <ActivationLanding setStep={setStep} config={activationConfig} handleKeyDown={handleKeyDown} />;
    }
    if (step === 2) {
        return <NewActivationScreen code={code} setStep={setStep} config={activationConfig} handleKeyDown={handleKeyDown} />;
    }

    return <></>;
};

export default ActivationSteps;
